import React from 'react';

import { SnackbarProvider } from 'notistack';

export default function AlertProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <SnackbarProvider autoHideDuration={1500} maxSnack={3}>
      {children}
    </SnackbarProvider>
  );
}
